export default function randomInt(min: number, max: number): number {
  return Math.floor(randomFloat(min, max));
}

export function randomFloat(min: number, max: number) {
  return Math.random() * (max - min) + min;
}
